export const INTEGER_PATTERN = /^[0-9]\d*$/;
export const VALUE_NEVER = 0;
export const PERIOD = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
